<template>

    <div>

        <modal
            :title="$t(modalTitle)"
            :width="520"
            cancel-text="Abbrechen"
            ok-text = "Übernehmen"
            transition="fadeDown"
            :show-ok="true"
            :show-cancel="true"
            :is-show="show"
            :on-cancel="close"
            :on-ok="save"
            :backdrop-closable="false"
            @close="close"
            class="editPersonModal vcenter">

                <div style="margin: 0 auto; width: 85%;">

                    <form-input inputType="select" label="PERSON_MODAL-GENDER" :isLeft="true" v-model="personModel.gender" :selectOptions="personGenders" :selectAllowEmpty="false" :showLabel="true" :showLabelInOptions="true"></form-input>
                    <form-input inputType="text" label="PERSON_MODAL-TITLE" :isRight="true" v-model="personModel.title" placeholder="Titel" :isHorizontal="false"></form-input>
                    <form-input inputType="text" label="PERSON_MODAL-FIRSTNAME" v-model="personModel.firstname" placeholder="Vorname" :isHorizontal="false"></form-input>
                    <form-input inputType="text" label="PERSON_MODAL-LASTNAME" v-model="personModel.lastname" placeholder="Nachname" :isHorizontal="false"></form-input>
                    <form-input inputType="text" label="PERSON_MODAL-EMAIL" v-model="personModel.email" placeholder="Email" :isHorizontal="false"></form-input>

                </div>

        </modal>

    </div>
</template>


<script>

export default {

    name: 'editPersonModal',

    props: {
        modalTitle: {
            type: String,
            default: 'Person bearbeiten'
        },
        show: {
            type: Boolean,
            default: false
        },
        person: {
            type: Object,
            default: () => ({
                gender: this.$store.getters.getTermsByTaxonomy('PERSON_GENDERS').MALE,
                firstname: 'Franz',
                lastname: 'Super',
                email: ''
            }),
            required: true
        }
    },

    computed: {

        personGenders() {
            return this.$store.getters.getTermsByTaxonomy('PERSON_GENDERS');
        },

    },

    data() {

        return {
            personModel: {}
        }

    },

    created() {


    },

    watch: {

        show(val) {

            if(val == true) {

                if(this.person == null) {

                    this.personModel = {
                        gender: this.$store.getters.getTermsByTaxonomy('PERSON_GENDERS').MALE,
                        firstname: '',
                        lastname: '',
                        email: ''
                    }

                } else {

                    this.personModel = this.person;

                }
            }

        }

    },

    methods: {

        close() {
            this.$emit('close');
            this.title = '';
            this.body = '';
            this.personModal = null;
        },

        save() {
            this.$emit('save', this.personModel);
            this.close();
        }
        
    }

}
</script>

<style>
.modal-card-body .control.isLeft .multiselect,
.modal-card-body .control.isRight .multiselect {
    min-width: 100px !important;
}
</style>
